import React, {  } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Tooltip } from '@mui/material/';
import { Box } from '@mui/material';
import { EnhancedTableHead } from '../EnhancedTableHead';
import TableSkeleton from '../TableSkeleton';
import { sortData } from '../../common/SortSupport';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import ButtonDefault from '../ButtonDefault';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { TextFieldWithoutBorders } from '../TextFieldWithoutBorders';
import { SwitchButton } from '../SwitchButton';

const ActionsTableSmall = (props:any) => {

  const { data, isLoading, handleChange, isReadOnly } = props;

  const initialAction = {
    "name": null,
    "description": null,
    "isAlreadyComplete": false,
  }

  const [t] = useTranslation();

  //supporting contents
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  let visibleRows = React.useMemo(
    () =>
      data && data.length > 0 &&
      sortData(data, orderBy, order),
    [order, orderBy, data],
  );

  const head = [
    {
      key: 'name', displayName: 'Action',
    },
    {
      key: 'description', displayName: 'Description',
    },
    {
      key: 'isAlreadyComplete', displayName: 'complete',
    },
    {
      key: '', displayName: '',
    },
  ]

  //table contents
    return(
        <React.Fragment>
            <Box sx={{ position: 'relative' }}>
              <Box sx={{ mt: 2, width: '100%', mb: '10px' }}>
                {
                  !isReadOnly &&
                  <ButtonDefault
                  variant={'outlined'}
                  value={t('ADD_ACTION')}
                  manageOnClick={() => {handleChange('addAction', initialAction, null)}}
                  icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                  />
                }
              </Box>
              <TableContainer 
              sx={{ 
                "& .MuiTable-root": {
                  border: 0,
                },
                "& .MuiTableCell-root": {
                  borderBottom: "none", // Remove bottom borders from table cells
                },
                "& .MuiTableRow-root": {
                  border: "none", // Remove row borders
                }
              }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                    {
                      !isLoading &&
                      visibleRows &&
                      visibleRows?.length ?
                          visibleRows.map((d: any, i: number) => (
                            <>
                              <TableRow
                              className='hoverBG'
                              sx={{ cursor: 'pointer' }}
                              key={`action-small-table-row-${i}`}
                              >
                              <TableCell className='fs12' sx={{ width: '40%' }}>
                                <TextFieldWithoutBorders 
                                isReadOnly={isReadOnly}
                                value={d.name}
                                handleChange={(e:any) => {handleChange('name', e.target.value, i)}}
                                bg={'#d3d3d3'}
                                fullWidth={true}
                                />
                              </TableCell>
                              <TableCell sx={{ width: '60%' }}>
                                <TextFieldWithoutBorders 
                                isReadOnly={isReadOnly}
                                value={d.description}
                                handleChange={(e:any) => {handleChange('description', e.target.value, i)}}
                                fullWidth={true}
                                bg={'#d3d3d3'}
                                />
                              </TableCell>
                              <TableCell className='fs12'>
                                <SwitchButton label={''} isOn={d?.isAlreadyComplete}
                                  handleOnClick={() => {handleChange('isAlreadyComplete', !d?.isAlreadyComplete)}} />
                              </TableCell>
                              <TableCell className='fs12'>
                                {
                                  !isReadOnly &&
                                  <Tooltip title={t('DELETE')} arrow placement='top'>
                                    <FontAwesomeIcon className='fs14 deleteIcon' 
                                    icon={faTrashCan}
                                    onClick={() => {handleChange('deleteAction', null, i)}} />
                                  </Tooltip>
                                }
                              </TableCell>
                              </TableRow>
                            </>
                          ))
                      :
                      (
                        !isLoading && !visibleRows ?
                          <TableRow>
                            <TableCell colSpan={head?.length} align="center" className='fs14 p20'>
                              {t('NO_ACTIONS_FOUND')}
                            </TableCell>
                          </TableRow> :
                          isLoading &&
                          <TableSkeleton rowCount={4} cellCount={head?.length} />
                      )
                    }
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
        </React.Fragment>
    )
}

export default ActionsTableSmall;